<template>
  <div
    id="marketing"
    class="page-content marketing"
  >
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <send-marketing-email />
        <add-promo-code />
        <send-physical-brochure />
        <inquiry />
        <send-bulk-sms page-id="marketing-send-bulk-sms" />
      </div>

      <div class="col-md-6 col-sm-6 col-xs-12">
        <go-go-mailings />
        <!-- <request-material /> -->
        <send-post-card />
      </div>

      <div class="col-12">
        <promos-table />
        <search-promo-codes-sent-to-users />
        <marketing-analytics-phone-numbers />
        <sms-templates />
        <custom-reports />
        <impact-partners v-if="isAdmin || isDirector" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent, toRefs } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useProfile } from '@/use/profile';

const SendPhysicalBrochure = defineAsyncComponent(() => import('./Marketing/SendPhysicalBrochure.vue') as any);

const SendPostCard = defineAsyncComponent(() => import('./Marketing/SendPostCard.vue') as any);

const GoGoMailings = defineAsyncComponent(() => import('./Marketing/GoGoMailings.vue') as any);

const Inquiry = defineAsyncComponent(() => import('./Marketing/Inquiry.vue') as any);

const AddPromoCode = defineAsyncComponent(() => import('./Marketing/AddPromoCode.vue') as any);

const SendMarketingEmail = defineAsyncComponent(() => import('./Marketing/SendMarketingEmail.vue') as any);

const SearchPromoCodesSentToUsers = defineAsyncComponent(() => import('./Marketing/SearchPromoCodesSentToUsers.vue') as any);

const MarketingAnalyticsPhoneNumbers = defineAsyncComponent(() => import('./Marketing/MarketingAnalyticsPhoneNumbers.vue') as any);

const PromosTable = defineAsyncComponent(() => import('./Marketing/PromosTable.vue') as any);

const SmsTemplates = defineAsyncComponent(() => import('./Marketing/SmsTemplates.vue') as any);

const CustomReports = defineAsyncComponent(() => import('./Marketing/CustomReports.vue') as any);

const ImpactPartners = defineAsyncComponent(() => import('./Marketing/ImpactPartners.vue') as any);

const SendBulkSms = defineAsyncComponent(() => import('./Management/SendBulkSms.vue') as any);

// const RequestMaterial = defineAsyncComponent(() => import('./Marketing/RequestMaterial.vue') as any);

const { userRoles } = useProfile();
const { isAdmin, isDirector } = toRefs(userRoles);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
